import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M18.9,4.1h-2.8c-0.5,0-1.1,0.2-1.1,1.2V8h3.8l-0.5,4.4h-3.4V25H9.9V12.4H7.4V8h2.5V5.2c0-2,0.9-5.2,5.2-5.2h3.8V4.1z" />
    </g>
  </svg>
);
